module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/guardian.8117cf16.png";